import http from "../http/http-config";
import { SaveMultiQuoteNotificationsResponse } from "../models/saveMultiQuoteNotificationsResponse";
import { SaveMultiQuoteNotificationsRequest } from "../models/SaveMultiQuoteNotificationsRequest";

export default new class SaveMultiQuoteNotificationsService {
    saveMultiQuoteNotifications(model: SaveMultiQuoteNotificationsRequest | null): Promise<SaveMultiQuoteNotificationsResponse> {
        return http.post<SaveMultiQuoteNotificationsResponse>("SaveMultiQuoteNotifications", model).then(response => response.data);
    }
}